import { render } from "./MFITTSeatMapSaloon.vue?vue&type=template&id=4c3ea4ea&scoped=true"
import script from "./MFITTSeatMapSaloon.vue?vue&type=script&lang=js"
export * from "./MFITTSeatMapSaloon.vue?vue&type=script&lang=js"

import "./MFITTSeatMapSaloon.vue?vue&type=style&index=0&id=4c3ea4ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c3ea4ea"

export default script